import {
  concat,
  difference,
  flow,
  get,
  groupBy,
  has,
  isNumber,
  isFunction,
  isObject,
  isString,
  join,
  keys,
  map,
  mapValues,
  merge,
  partialRight,
  values,
} from 'lodash';
import flatten from 'flat';
import defaultTheme from '@cld/themes';
import generateNewTheme from './generateNewTheme';

const combineValues = (...functions) => {
  const resultFunc = functions.pop();

  return (props) => {
    if (isFunction(resultFunc)) {
      return resultFunc(...map(functions, (func) => (isFunction(func) ? func(props) : func)));
    }
  };
};

//TODO: fix
const checkThemeSchema = (theme) => {
  const mappingsPaths = values('this got the mappings');
  const themeFlatten = keys(flatten(theme));

  const results = groupBy(mappingsPaths, (path) => (has(theme, path) ? 'FOUND' : 'MISSING'));
  results['REDUNDANT'] = difference(themeFlatten, mappingsPaths);

  return results;
};

const switchProp = (attrNameOrFunction, mappings) => (props) => {
  const val = get(mappings, typeof attrNameOrFunction === 'function' ? attrNameOrFunction(props) : get(props, attrNameOrFunction));
  if (isFunction(val)) {
    return val(props);
  }
  if (isString(val)) {
    return val;
  }
};

const getThemeValue = (theme, path, foundKeys = new Set()) => {
  const value = get(theme, path);
  if (!value || (!isString(value) && !isNumber(value))) {
    return path;
  }
  if (foundKeys.has(path)) {
    throw new Error(`Cyclic theme references: ${JSON.stringify(foundKeys)}`);
  }

  foundKeys.add(path);
  return getThemeValue(theme, value, foundKeys);
};

const getThemeObject = (theme, reference = []) => {
  return flow(
    partialRight(get, join(reference, '.'), theme),
    partialRight(mapValues, (value, key) => (isObject(value) ? getThemeObject(theme, concat(reference, key)) : getThemeValue(theme, value)))
  )(theme);
};

const generateTheme = (...themes) => getThemeObject(merge({}, defaultTheme, ...themes));

export { generateTheme, switchProp, generateNewTheme, checkThemeSchema, combineValues };
